import mwrHttp from '@/utils/activityHttp'
import store from '@/store'
import ta from 'thinkingdata-browser'

// 开发走本地代理前缀；其他环境用 VUE_APP_ACT_URL
const actHost =
  process.env.VUE_APP_ENV === 'dev'
    ? ''
    : String(process.env.VUE_APP_ACT_URL || '').replace(/\/$/, '')
const basePath = `${actHost}/minifire-hw/api/v1/hw`
const basePathCommon = `${actHost}/minifire-hw/api/v1`
const basePath2 = `${actHost}/minifire_account_server_os/api/v1`

export default {
  gameTokenLogin: async (params) => {
    try {
      const res = await mwrHttp.post(`${basePath2}/game/gameTokenLogin`, params)
      store.commit('SET_ACT_USER_INFO', {
        token: res.authorization,
        expireAt: res.expireAt,
        ...res.roleInfo,
      })
      const uid = store.state.actUserInfo.uid || ''
      if (uid) ta.login(uid)
    } catch (error) {
      console.error(error)
    }
    location.href = location.origin + location.pathname
  },

  loginByMailCode: async (params) => {
    const res = await mwrHttp.post(`${basePath2}/game/gameMailLogin`, params)
    store.commit('SET_ACT_USER_INFO', {
      token: res.authorization,
      expireAt: res.expireAt,
      ...res.roleInfo,
    })
    return res
  },

  sendMailCode: (params) => {
    return mwrHttp.post(`${basePath2}/game/sendGameMailVerifyCode`, params)
  },

  getCommonConfig: (params) => {
    return mwrHttp.post(`${basePathCommon}/get-common-config`, params)
  },

  getActivityInfo: (params) => {
    return mwrHttp.post(`${basePath}/activity-info`, params)
  },

  getGlobalProgress: (params) => {
    return mwrHttp.post(`${basePath}/global-progress`, params)
  },

  receiveFirstLoginReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-first-login-reward`, params)
  },

  getTaskList: (params) => {
    return mwrHttp.post(`${basePath}/task-list`, params)
  },

  receiveTaskReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-task-reward`, params)
  },

  share: (params) => {
    return mwrHttp.post(`${basePath}/share`, params)
  },

  strike: (params) => {
    return mwrHttp.post(`${basePath}/strike`, params)
  },

  receiveGlobalReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-global-reward`, params)
  },

  getMilestoneList: (params) => {
    return mwrHttp.post(`${basePath}/milestone-list`, params)
  },

  receiveMilestone: (params) => {
    return mwrHttp.post(`${basePath}/receive-milestone`, params)
  },

  getRewardRecord: (params = {}) => {
    return mwrHttp.post(`${basePath}/reward-record`, params)
  },
}
